const Summary = ({ data }) => {
	return (
		<table
			className="approved assigned"
			style={{ marginTop: "10px", marginBottom: "5px" }}
		>
			<thead>
				<tr>
					<th
						colSpan="5"
						style={{
							padding: "0",
							paddingTop: "14px",
							paddingBottom: "7.5px",
							background: "#fff",
						}}
					>
						<h3
							style={{
								borderBottom: "none",
								marginTop: "0",
								marginBottom: "0",
								fontSize: "1.15rem",
							}}
						>
							JW Marriott (Guaranteed Rooms)
						</h3>
					</th>
				</tr>
				<tr>
					<th className="center" style={{ width: "20%" }}>
						Wed, March 31
					</th>
					<th className="center" style={{ width: "20%" }}>
						Thu, April 1
					</th>
					<th className="center" style={{ width: "20%" }}>
						Fri, April 2
					</th>
					<th className="center" style={{ width: "20%" }}>
						Sat, April 3
					</th>
					<th className="center" style={{ width: "20%" }}>
						Sun, April 4
					</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td className="center">{data.wed ? `${data.wed} reserved` : "--"}</td>
					<td className="center">{data.thu ? `${data.thu} reserved` : "--"}</td>
					<td className="center">{data.fri ? `${data.fri} reserved` : "--"}</td>
					<td className="center">{data.sat ? `${data.sat} reserved` : "--"}</td>
					<td className="center">{data.sun ? `${data.sun} reserved` : "--"}</td>
				</tr>
			</tbody>
		</table>
	);
};

export default Summary;
